import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const openRegistrationExampleHtml = `
<div class="registration-card-docs__canvas">
  <se-open-registration-card
    orgName="Warriors Hockey"
    registrationName="2025-26 Player Registration"
    orgColor="#df153d"
    sport="Hockey"
    type="Registration"
    backgroundImgUrl="https://images.unsplash.com/photo-1580748141549-71748dbe0bdc?auto=format&fit=crop&w=1200&q=80"
    infoHeaderText="Registration Open"
    infoText="Aug 02, 2025 - Nov 12, 2025"
    buttonLinkUrl="https://www.sportsengine.com/"
    buttonText="Sign up">
  </se-open-registration-card>
</div>
`

const completedRegistrationExampleHtml = `
<div class="registration-card-docs__canvas">
  <se-open-registration-card
    orgName="Basketball Academy"
    orgLogoUrl="https://placehold.co/188x188/0b1f3a/facc15?text=HOOPS+CLUB"
    orgColor="#927600"
    registrationName="2025-26 Player Registration"
    sport="Basketball"
    type="Registration"
    avatarUrl="https://images.unsplash.com/photo-1675818195695-e32b695e939b?auto=format&fit=crop&w=300&q=80"
    backgroundImgUrl="https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1600&q=80"
    infoHeaderText="Registration completed Oct 14, 2025"
    orderRouterLinkText="Order Details"
    orderRouterLink="/orders/123">
  </se-open-registration-card>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class RegistrationCardExampleComponent {}
`

@Component({
  selector: 'se-open-registration-card-example',
  template: `
    <se-fe-docs-example [example]="openRegistrationExample">
      <div class="registration-card-docs__canvas">
        <se-open-registration-card
          orgName="Warriors Hockey"
          registrationName="2025-26 Player Registration"
          orgColor="#df153d"
          sport="Hockey"
          type="Registration"
          backgroundImgUrl="https://images.unsplash.com/photo-1580748141549-71748dbe0bdc?auto=format&fit=crop&w=1200&q=80"
          infoHeaderText="Registration Open"
          infoText="Aug 02, 2025 - Nov 12, 2025"
          buttonLinkUrl="https://www.sportsengine.com/"
          buttonText="Sign up"
        >
        </se-open-registration-card>
      </div>
    </se-fe-docs-example>
    <se-fe-docs-example [example]="completedRegistrationExample">
      <div class="registration-card-docs__canvas">
        <se-open-registration-card
          orgName="Basketball Academy"
          orgLogoUrl="https://placehold.co/188x188/0b1f3a/facc15?text=HOOPS+CLUB"
          orgColor="#927600"
          registrationName="2025-26 Player Registration"
          sport="Basketball"
          type="Registration"
          avatarUrl="https://images.unsplash.com/photo-1675818195695-e32b695e939b?auto=format&fit=crop&w=300&q=80"
          backgroundImgUrl="https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1600&q=80"
          infoHeaderText="Registration completed Oct 14, 2025"
          orderRouterLinkText="Order Details"
          orderRouterLink="/orders/123"
        >
        </se-open-registration-card>
      </div>
    </se-fe-docs-example>
  `,
  styleUrls: ['./registration-card-docs.component.scss'],
  standalone: false,
})
export class RegistrationCardExampleComponent extends SeFeDocsExampleComponent {
  public openRegistrationExample = {
    files: [
      { src: openRegistrationExampleHtml, name: 'Template', lang: 'html' },
      { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
    ],
  } as SeFeDocsExampleComponent

  public completedRegistrationExample = {
    files: [
      { src: completedRegistrationExampleHtml, name: 'Template', lang: 'html' },
      { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
    ],
  } as SeFeDocsExampleComponent

  public files = this.openRegistrationExample.files

  constructor() {
    super()
  }
}
